import Loadable from "app/components/Loadable";
import { lazy } from "react";

const VisitDayList = Loadable(lazy(() => import("./VisitDayList")));
const VisitDayForm = Loadable(lazy(() => import("./VisitDayForm")));

const visitDayRoutes = [
    {
        path: "/VisitDay/VisitDayList",
        element: <VisitDayList />,
    },
    {
        path: "/VisitDay/VisitDayForm",
        element: <VisitDayForm />,
    },
    {
        path: "/VisitDay/VisitDayForm/:visitDayId",
        element: <VisitDayForm />,
    },
];

export default visitDayRoutes;
